<template>
  <button 
    class="info-button" 
    @click.stop="$emit('click', $event)"
    :title="title"
    :aria-label="title || 'En savoir plus'"
    :data-testid="testId"
  >
    <i class="fas fa-info-circle"></i>
  </button>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: 'En savoir plus'
  },
  testId: {
    type: String,
    default: null
  }
})

defineEmits(['click'])
</script>

<style scoped>
.info-button {
  background: transparent;
  border: none;
  color: var(--color-primary);
  cursor: pointer;
  padding: var(--spacing-xs);
  border-radius: var(--radius-sm);
  transition: all var(--transition-base);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  margin-left: var(--spacing-xs);
}

.info-button:hover {
  background: var(--color-bg-secondary);
  color: var(--color-primary-dark);
  transform: scale(1.1);
}

.info-button:active {
  transform: scale(0.95);
}

.info-button i {
  font-size: 0.9rem;
}
</style>

